import React from 'react';
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import reqwest from 'reqwest';
import { Button, Modal, notification, Spin, Alert, Icon} from 'antd';
// import components
// <PreviewContent/> component is for pre-v2.0.0, currently deprecated
// import PreviewContent from '../components/PreviewSession.Content';
import SessionCheckList from '../components/PreviewSession.CheckList';

function setErrorMsg(error) {
  return {
    registerError: error
  }
}

class PreviewSession extends React.Component{
  constructor(props){
    super(props);
    this.state = {
      registerError: null,
      visible: false,
      loading: false,
      submitConfirm: false,
    }
  }

  preview=()=>{
    this.setState({visible: true,});
  }

  handleCancel=()=>{
    this.setState({visible: false,});
  }

  showConfirmModal=()=>{
    if(this.props.parameters.selectedRaw.length === 0){
      this.setState(setErrorMsg('You have to select at least one file to proceed.'));
    }else{
      this.setState({submitConfirm: true});
    }
  }

  hideConfirmModal=()=>{
    this.setState({
      submitConfirm: false,
      registerError: null,
    });
  }

  submit=(url_init, url_exec, parameters, sessID)=>{
    this.setState({
      submitConfirm: false,
      loading: true,
    });

    reqwest({
      url: url_init,
      method: 'post',
      data: {parameters: parameters, sess_id: sessID},
      crossOrigin: true,
      success: (_data) => {
        console.log(_data);
        let data = JSON.parse(_data);
        //console.log(data);

        this.setState({
          loading: false,
          visible: false,
        });

        if(data.success !== ""){
          const key = `open${Date.now()}`;
          // const btnClick = function () {
          //     // to hide notification box, notification api
          //     notification.close(key);
          // };
          const btn = (
              <div className="cus-btn-style">
                  <Icon type="sync" />
                  <a href="/#/dataprocessing/results">Start Tracking</a>
              </div>
          );
          notification.success({
            message: 'Submission successful',
            description: (<div><p>Your session was successfully submitted</p><p>Proceed to "View Results" to track session progress.</p></div>),
            key,
            onClose: this.closeNotification,//defined here
            duration: 25,
          });

          reqwest({
            url: url_exec,
            method: 'post',
            data: {sess_id: sessID},
            crossOrigin: true,
            success: (_data) => {
              console.log("success");
              //console.log(_data);
            },
            error: (error)=>{
              //console.log(error);
            }
          });

          }else if(data.error !== ""){
              //console.log("error: " + data.error);
          }else{
              //console.log("error: unknown, go check the php script");
          }   
        },
        error: (error) => {
          //console.log(error);
          this.setState({
            loading: false,
            visible: false,
          });
          //optional, may not needed
          //this.setState(setErrorMsg('submission failed.'));
          const key = `open${Date.now()}`;
          notification.error({
            message: 'Submission failed',
            description: `Submission to iMetaLab server failed.
                        Please try again.`,
            //description: `${error}`,
            key,
            onClose: this.closeNotification,//defined here
            duration: 20,
          });
        },
    });
  }
  
  //triggered when the cross button was clicked, currently not being used
  closeNotification = () => {
    // sign out?
    //specify an action upon closing
    //console.log('Notification was closed.');
  };
  
  render(){
    //console.log(this.props);
    const {email, parameters, sessID, SERVER_APIS} = this.props;
    const {loading, submitConfirm, visible, registerError} = this.state;

    return(
    <div style={{ display: 'inline', marginLeft: 8 }}>
      <Button type="primary"
        icon="eye-o"
        onClick={this.preview}>Preview
      </Button>
      <Modal
        width="950px"
        visible={visible}
        //onOk={this.handleOk}
        onCancel={this.handleCancel}
        footer={[
          <Button key="back" size="large" 
            onClick={this.handleCancel}>
            Back
          </Button>,
          <Button key="submit" type="primary" size="large" 
            onClick={this.showConfirmModal}>
            Submit
          </Button>,]}>

        <Modal
          title="Confirm on Submission"
          visible={submitConfirm}
          onOk={()=>this.submit(`${SERVER_APIS.SERVER_URL}${SERVER_APIS.INIT_SESSION}`, `${SERVER_APIS.SERVER_URL}${SERVER_APIS.EXEC_SESSION}`, parameters, sessID)}
          onCancel={this.hideConfirmModal}
          okText="Yes"
          cancelText="No">
          <h4>Make sure you have reviewed all the parameters.</h4>
          <h4>Press "Yes" to submit the session.</h4>
        </Modal>

        <Spin tip="Connecting to iMetaLab server..." 
          size='large'
          spinning={loading}
          style={{marginTop: 650}}>

          <SessionCheckList 
            email={email}
            sessID={sessID}
            parameters={parameters} />

          {
            registerError
            &&
            <Alert description={registerError} type="error"/>
          }
        </Spin>
      </Modal>
    </div>
    );
  }
}

export default PreviewSession;